import { GenericBladeInitParam, GenericBladeType } from '@commblades/commblades';

const { applicationRoot } = window.NetBank;

const applicationStartState: GenericBladeInitParam = {
    id: 'get-started',
    genericBladeType: GenericBladeType.confirm,
    urlFetchEndPoint: `${applicationRoot}getstarted`,
    urlSubmitEndPoint: undefined,
    content: {
        heading: 'How much can you borrow?',
        description: `We ask a few simple questions, such as income and expenses to estimate how much you can borrow with our personal loan.  
        We’ll also guide you choosing what loan type is right for your needs.`,
        notificationText: 'This tool doesn\'t consider your financial circumstances or loan eligibility.',
        confirmButtonText: 'Get started',
    },
};

export default applicationStartState;
